import { render, staticRenderFns } from "./SubjectStatusCount.vue?vue&type=template&id=51fa7f8b&scoped=true&"
import script from "@/components/curriculum/SubjectStatusCount.ts?vue&type=script&lang=ts&"
export * from "@/components/curriculum/SubjectStatusCount.ts?vue&type=script&lang=ts&"
import style0 from "@/components/curriculum/subject-status-count.scss?vue&type=style&index=0&id=51fa7f8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fa7f8b",
  null
  
)

export default component.exports